/* eslint-disable no-debugger */
/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, { Component } from 'react';
import { Search } from './SearchComponent';
import { SearchInput } from "./SearchInput";
import { SEARCH_OPTIONS, TEXT_TYPES } from "../../../constants/APP_CONSTANTS";
import ReactTable from 'react-table';
import Svg from '../../widgets/Svg/Svg';
import AxiosClient from '../../../_helpers/http.helper';
import find from 'lodash/find';
import moment from 'moment';
import config from "../../../config";
import { formatUrl } from "../../../_helpers/url.format.helper";
import InfiniteScroll from 'react-infinite-scroll-component';
import MetadataEditPanel from './MetadataEditPanel';
import { MetadataPopup } from './MetadataPopupComponent';
import LoadingIndicator from "../../widgets/LoadingIndicator/LoadingIndicator";


export default class ContentManagement extends Component {
    constructor(props) {
        super(props);
        this.state = {
            resultset: {
                csgMasterMetadataDTOList: [],
                totalItems: 0,
                resourceList: []
            },
            resourceType: "scrubbed",
            searchInput: {
                searchParam: "",
                searchValue: "",
                startDate: "",
                endDate: "",
                datepicker: false,
                placeholder: SEARCH_OPTIONS.FILTER,
                searchDisabled: true,
                pageNumber: 0,
                pageSize: 100
            },
            hasMore: true,
            selected: [],
            showResults: false,
            showPopup: false,
            currentMetadataSet: {},
            showLoader: false
        };
    }

    handleResourceOptionChange(e) {
        this.setState({
            resourceType: e.target.value
        });
    }

    loadMore = () => {
        let pageNumber
            = this.state.resultset.csgMasterMetadataDTOList.length
            / this.state.searchInput.pageSize;
        this.onSearch(pageNumber);
    };

    onSearch = pageNumber => {
        this.clearSelected();
        if (pageNumber === 0) {
            this.setState({
                resultset: {
                    csgMasterMetadataDTOList: [],
                    totalItems: 0,
                    resourceList: []
                },
                showLoader: true
            });
        }
        const params = {
            searchParam: this.state.searchInput.searchParam,
            contentSelection: this.state.resourceType,
            searchValue: this.state.searchInput.searchValue,
            startDate: this.state.searchInput.startDate,
            endDate: this.state.searchInput.endDate,
            pageNumber:
                this.state.resultset.csgMasterMetadataDTOList.length == 0
                    ? 0
                    : parseInt(pageNumber),
            pageSize: this.state.searchInput.pageSize
        };

        this.getResources(params)
            .then(response => this.setStateData(response))
            .catch(() =>
                this.setState({
                    showResults: true
                })
            );
    };

    setStateData = data => {
        let metadataList = this.state.resultset.csgMasterMetadataDTOList;
        let resourceList = this.state.resultset.resourceList;
        metadataList = metadataList.concat(data.csgMasterMetadataDTOList);
        resourceList = resourceList.concat(data.resourceList);
        this.setState({
            resultset: {
                csgMasterMetadataDTOList: metadataList,
                resourceList: resourceList,
                totalItems: data.totalItems
            },
            hasMore: data.totalItems > metadataList.length,
            showLoader: false,
            showResults: true
        });
    };

    updateSearchParams = params => {
        this.setState(prevState => {
            return {
                ...prevState,
                resultset: {
                    csgMasterMetadataDTOList: [],
                    totalItems: 0,
                    resourceList: []
                },
                searchInput: {
                    ...prevState.searchInput,
                    searchValue: "",
                    searchParam: params.searchParam,
                    placeholder: params.placeholder,
                    datepicker: params.datepicker,
                    searchDisabled: params.searchDisabled
                },
                showResults: false,
                selected: []
            };
        });
    };

    updateSearchValues = searchValue => {
        this.setState(prevState => {
            return {
                searchInput: {
                    ...prevState.searchInput,
                    searchValue: searchValue
                }
            };
        });
    };

    updateFromDate = date => {
        this.setState(prevState => {
            return {
                searchInput: {
                    ...prevState.searchInput,
                    startDate: moment(date).format("YYYY-MM-DD")
                }
            };
        });
    };

    updateEndDate = date => {
        this.setState(prevState => {
            return {
                searchInput: {
                    ...prevState.searchInput,
                    endDate: moment(date).format("YYYY-MM-DD")
                }
            };
        });
    };

    togglePopup(data) {
        this.setState({
            currentMetadataSet: data.original,
            showPopup: !this.state.showPopup
        });
        this.setState(prevState => ({
            currentMetadataSet: {                   
                ..._.omit(prevState.currentMetadataSet,  'id'),    
                sharing: this.getResourceSharingValue(data.row._original.csgResourceId),
                csgMasterMetadataId : prevState.currentMetadataSet.id,
            }
        }));
    }

    closePopup = () => {
        this.setState({
            showPopup: !this.state.showPopup
        });
    }

    toggleRow(csgResourceId) {
        this.setState(prevState => ({
            selected: prevState.selected.includes(csgResourceId)
                ? prevState.selected.filter(word => word !== csgResourceId)
                : prevState.selected.concat([csgResourceId])
        }));
    }

    toggleSelectAll() {
        this.setState(prevState => ({
            selected:
                prevState.selected.length
                === prevState.resultset.csgMasterMetadataDTOList.length
                    ? []
                    : prevState.resultset.resourceList.map(
                        item => item.resourceId
                    )
        }));
    }

    formatGetUrl(url, options, path) {
        let searchRoute = config.contentService.routes.searchUrl;
        return formatUrl(
            config.contentService.baseUrl,
            searchRoute.concat(path).concat(options.searchValue.trim()),
            {
                queryParams: {
                    contentSelection: options.contentSelection,
                    pageNumber: options.pageNumber,
                    pageSize: options.pageSize
                }
            }
        );
    }

    formatPostUrl(url, options, path) {
        let searchRoute = config.contentService.routes.searchUrl;
        return formatUrl(
            config.contentService.baseUrl,
            searchRoute.concat(path),
            {
                queryParams: {
                    pageNumber: options.pageNumber,
                    pageSize: options.pageSize
                }
            }
        );
    }

    getResources = options => {
        let url = "";
        let valueArray = "";
        let searchRoute = config.contentService.routes.searchUrl;

        switch (options.searchParam) {
            case 'metadatabyname': {
                url = formatUrl(
                    config.contentService.baseUrl,
                    searchRoute.concat("filename"),
                    {
                        queryParams: {
                            contentSelection: options.contentSelection,
                            fileName: options.searchValue.trim(),
                            pageNumber: options.pageNumber,
                            pageSize: options.pageSize
                        }
                    }
                );
                return AxiosClient.get(url).then(res => res.data);
            }
            case 'metadatabyId': {
                url = this.formatGetUrl(url, options, "id/");
                return AxiosClient.get(url).then(res => res.data);
            }
            case 'metadataByAssetTitle': {
                url = formatUrl(
                    config.contentService.baseUrl,
                    searchRoute.concat("assettitle"),
                    {
                        queryParams: {
                            contentSelection: options.contentSelection,
                            assetTitle: options.searchValue.trim(),
                            pageNumber: options.pageNumber,
                            pageSize: options.pageSize
                        }
                    }
                );
                return AxiosClient.get(url).then(res => res.data);
            }
            case 'metadatabydate': {
                url = formatUrl(
                    config.contentService.baseUrl,
                    searchRoute.concat("date"),
                    {
                        queryParams: {
                            contentSelection: options.contentSelection,
                            startdate: options.startDate,
                            enddate: options.endDate,
                            pageNumber: options.pageNumber,
                            pageSize: options.pageSize
                        }
                    }
                );

                return AxiosClient.get(url).then(res => res.data);
            }
            case 'metadataByIds': {
                url = this.formatPostUrl(url, options, "ids");
                valueArray = options.searchValue.replace(/\s/g, "").split(",");
                return AxiosClient.post(url, {
                    contentSelection: options.contentSelection,
                    resourceIds: valueArray
                }).then(res => res.data);
            }
            case 'metadataByEpsId': {
                url = this.formatPostUrl(url, options, "epsids");
                valueArray = options.searchValue.replace(/\s/g, "").split(",");
                return AxiosClient.post(url, {
                    contentSelection: options.contentSelection,
                    epsIds: valueArray
                }).then(res => res.data);
            }
            case 'metadataByISBN': {
                valueArray = options.searchValue.replace(/\s/g, "").split(',');
                url = this.formatPostUrl(url, options, "isbns");
                return AxiosClient.post(url, {
                    contentSelection: options.contentSelection,
                    isbns: valueArray
                }).then(res => res.data);
            }
            case 'metadataByFileNames': {
                url = this.formatPostUrl(url, options, "filenames");
                valueArray = options.searchValue.replace(/\s/g, "").split(",");
                return AxiosClient.post(url, {
                    contentSelection: options.contentSelection,
                    fileNames: valueArray
                }).then(res => res.data);
            }
            default:
        }
    };

    getResourceSharingValue = csgResourceId => {
        let resourceObj = find(this.state.resultset.resourceList, resource => {
            if (resource.resourceId === csgResourceId) {
                return resource.sharing;
            }
        });
        return resourceObj.sharing;
    };

    clearSelected = () => {
        this.setState({
            selected: []
        });
    };

    refreshSearch = () => {
        this.setState(prevState => ({
            resultset: {
                csgMasterMetadataDTOList: [],
                totalItems: 0,
                resourceList: []
            },
            searchInput: {
                ...prevState.searchInput,
                pageNumber: 0,
                pageSize: 100
            }
        }));

        this.onSearch(0);
    }

    render() {
        const columns = [
            {
                Header: () => {
                    return (
                        <input
                            type="checkbox"
                            className="checkbox"
                            checked={
                                this.state.resultset
                                && this.state.resultset.csgMasterMetadataDTOList
                                && this.state.selected
                                && this.state.selected.length
                                    === this.state.resultset
                                        .csgMasterMetadataDTOList.length
                            }
                            ref={input => {
                                if (input) {
                                    input.indeterminate
                                        = this.state.selected.length
                                        && this.state.selected.length
                                            !== this.state.resultset
                                                .csgMasterMetadataDTOList
                                                .length;
                                }
                            }}
                            onChange={() => this.toggleSelectAll()}
                        />
                    );
                },
                Cell: row => (
                    <input
                        checked={this.state.selected.includes(
                            row.original.csgResourceId
                        )}
                        type="checkbox"
                        className="checkboxColumn"
                        onChange={() =>
                            this.toggleRow(row.original.csgResourceId)
                        }
                    />
                ),
                width: 60
            },
            {
                Header: "Asset Title",
                accessor: "assetTitle",
                sortable: true
            },
            {
                Header: "Unscrubbed",
                accessor: "unscrubbed",
                Cell: v => (v.value ? "True" : "False"),
                sortable: true,
                width: 100
            },
            {
                Header: "File Name",
                accessor: 'fileName',
                sortable: true,
                Cell: (data) => <a id={data.original.csgResourceId} style={{ cursor: 'pointer' }} onClick={(e) => this.togglePopup(data)}>{data.value}</a>
            },
            {
                Header: "ISBN 10",
                accessor: "isbn10",
                sortable: true
            },
            {
                Header: "ISBN 13",
                accessor: "isbn13",
                sortable: true
            },
            {
                Header: "Auth Last",
                accessor: "authLast",
                sortable: true
            },
            {
                Header: "Program Component Title",
                accessor: "programComponentTitle",
                sortable: true
            },
            {
                Header: "EPS ID",
                accessor: "epsItemId",
                sortable: true,
                style: { 'whiteSpace': 'unset' }
            },
            {
                Header: "Last Modified",
                sortable: true,
                style: { 'whiteSpace': 'unset' },
                accessor: 'lastModified',
                Cell: (row) => (row.value) ? moment(row.value).local().format("MM-DD-YYYY") : ""
            },
            {
                Header: "Visible",
                accessor: "sharing",
                sortable: true,
                width: 55,
                Cell: data =>
                    this.getResourceSharingValue(
                        data.original.csgResourceId
                    ) === "Public" ? (
                            <Svg svgString={"show-on-18"} />
                        ) : (
                            <Svg svgString={"show-off-18"} />
                        )
            }
        ];
        return (
            <div>
                <div className="CM-container pe-row">
                    <div className="content-home-page">
                        <label className="pe-page-title--small">Content Management</label>
                        <hr />
                        <div className="pe-row  search">
                            <div className='pe-col-4 searchInput'>
                                <Search updateSearchParams={(e) => this.updateSearchParams(e)} />
                            </div>
                            <div className='pe-col-6 searchInput'>
                                <SearchInput updateFromDate={this.updateFromDate}
                                    updateEndDate={this.updateEndDate}
                                    updateSearchValues={this.updateSearchValues}
                                    options={this.state.searchInput}
                                    triggerSearch={() => this.onSearch(0)}
                                />
                            </div>
                            <div className="pe-col-2  searchBtn">
                                <button className="pe-btn" onClick={() => this.onSearch(0)}
                                    disabled={this.state.searchInput.searchValue || (this.state.searchInput.startDate && this.state.searchInput.endDate) ? false : true}>Search
                                </button>
                            </div>
                        </div>
                        <div className='pe-row resource-type'>

                            <div className='pe-col-2 radio-btn '>
                                <div className="pe-radio scrubbed">
                                    <input type="radio" name="resource-type" id="scrubbed" value='scrubbed'
                                        checked={this.state.resourceType === 'scrubbed' ? true : false}
                                        onChange={(e) => this.handleResourceOptionChange(e)} />
                                    <label htmlFor="scrubbed">Scrubbed</label>
                                    <span>
                                        <svg aria-hidden="true" focusable="false" className="pe-icon--radio-dot">
                                            <use xlinkHref="#new-notification-9"></use>
                                        </svg>
                                    </span>
                                </div>
                            </div>
                            <div className='pe-col-2 radio-btn'>
                                <div className="pe-radio unscrubbed">
                                    <input type="radio" name="resource-type" id="unscrubbed" value='unscrubbed'
                                        checked={this.state.resourceType === 'unscrubbed' ? true : false}
                                        onChange={(e) => this.handleResourceOptionChange(e)} />
                                    <label htmlFor="unscrubbed">Unscrubbed</label>
                                    <span>
                                        <svg aria-hidden="true" focusable="false" className="pe-icon--radio-dot">
                                            <use xlinkHref="#new-notification-9"></use>
                                        </svg>
                                    </span>
                                </div>
                            </div>
                            <div className='pe-col-2 radio-btn'>
                                <div className="pe-radio">
                                    <input type="radio" name="resource-type" id="both" value='both'
                                        checked={this.state.resourceType === 'both' ? true : false}
                                        onChange={(e) => this.handleResourceOptionChange(e)} />
                                    <label htmlFor="both">Both</label>
                                    <span>
                                        <svg aria-hidden="true" focusable="false" className="pe-icon--radio-dot">
                                            <use xlinkHref="#new-notification-9"></use>
                                        </svg>
                                    </span>
                                </div>
                            </div>
                            <div className='pe-col-3'></div>
                        </div>
                    </div>
                    {this.state.showLoader ? <LoadingIndicator/> : this.state.resultset ? this.state.resultset.totalItems > 0 ?
                        <div>
                            <div id="scrollTable" className="infiniteScroll">
                                <InfiniteScroll
                                    dataLength={this.state.resultset.csgMasterMetadataDTOList.length}
                                    next={this.loadMore}
                                    hasMore={this.state.hasMore}
                                    scrollableTarget="scrollTable"
                                    loader={<LoadingIndicator isDark = {false}/>}
                                >
                                    <div className="table-wrap">
                                        <ReactTable
                                            className="-highlight"
                                            data={this.state.resultset.csgMasterMetadataDTOList}
                                            showPagination={false}
                                            columns={columns}
                                            defaultPageSize={this.state.resultset.totalItems}
                                            minRows={0}
                                            sortable={false}
                                            pageText=""
                                            noDataText={TEXT_TYPES.RESOURCE_NOT_FOUND} />
                                    </div>


                                </InfiniteScroll>
                            </div>
                        </div> : this.state.showResults ? <div className="table-wrap">
                            <ReactTable
                                className="-highlight"
                                showPagination={false}
                                columns={columns}
                                minRows={0}
                                sortable={false}
                                pageText=""
                                noDataText={TEXT_TYPES.RESOURCE_NOT_FOUND} />
                        </div> : '' : ''
                    }

                </div>
                {this.state.selected && this.state.selected.length > 0
                    && <MetadataEditPanel
                        metadata={this.state.resultset.csgMasterMetadataDTOList}
                        resources={this.state.resultset.resourceList}
                        clearSelected={this.clearSelected}
                        selected={this.state.selected}
                        refreshSearch={this.refreshSearch} />}

                <div className='app'>
                    {this.state.showPopup ?
                        <MetadataPopup
                            currentMetadataSet={this.state.currentMetadataSet}
                            text={TEXT_TYPES.RESOURCE_METADATA}
                            closePopup={this.closePopup}
                        />
                        : null
                    }
                </div>
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/ContentManagement/ContentManagement.js